import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import CMSComponents, { GetComponent, components } from '@sainsburys-tech/bolt-cms-components'
// import { ProductCard } from '@sainsburys-tech/fable'
import * as Styled from './CustomerGeneratedContentWrapper.styles'

const CustomerGeneratedContentWrapper = ({ className = '', productId = '', tags = [], isFullWidth }) => {
  return (
    <>
      <Styled.Section isFullWidth={isFullWidth} className={className} data-test='pdp-social-media-content-cgc-wrapper'>
        <CMSComponents components={components}>
          <ErrorBoundary>
            <GetComponent
              type='C002'
              heading='Customer gallery'
              bodyCopy='Styled by you, loved by us. Click on the photos below to shop the look. To feature in our galleries, tag your photos with @HabitatUK or @Argos on Instagram.'
              productIdentifier={productId}
              tags={tags}
            />
          </ErrorBoundary>
        </CMSComponents>
      </Styled.Section>
      {/* Spike to test the integration of fable components to replace bolt components */}
      {/* <Styled.Section isFullWidth={isFullWidth} className={className} data-test='pdp-social-media-content-cgc-wrapper'>
        <ProductCard
          title='Product Card Title'
          image={
            <div className='ds-max-w-full'>
              <img
                src='https://picsum.photos/seed/picsum/200/200'
                alt='Product Card placeholder'
                className='ds-w-full ds-max-w-full ds-object-cover ds-object-center'
              />
            </div>
          }
          rating={{
            count: 120,
            value: 4.5
          }}
          badges={[
            {
              type: 'clearance'
            },
            {
              type: 'new'
            },
            {
              label: 'badge 3',
              type: 'green',
              variant: 'secondary'
            }
          ]}
          price={{
            price: '£1.00',
            type: 'default'
          }}
          ctaButton={{
            label: 'Add to basket',
            href: 'http://www.example.com',
            onClick: () => {}
          }}
          secondaryCtaButton={{
            label: 'Add to favourites',
            href: 'http://www.example.com',
            onClick: () => {}        }}
        />
      </Styled.Section> */}
    </>
  )
}

CustomerGeneratedContentWrapper.propTypes = {
  className: PropTypes.string,
  isFullWidth: PropTypes.bool,
  productId: PropTypes.string,
  tags: PropTypes.array
}

CustomerGeneratedContentWrapper.defaultProps = {
  className: '',
  isFullWidth: false,
  productId: '',
  tags: []
}

export default CustomerGeneratedContentWrapper
